import React from 'react';
import * as ReactDOM from 'react-dom';
import { Toaster } from './toast.component';
export class ToastService {
    constructor() {
        // Close toast popup
        this.handleClose = (type) => {
            this.showToast({ open: false, type: type || "Success" /* ToastType.Success */ });
        };
        // finding a container to show the toaster
        this.getToasterContainer = () => {
            // creating dynamic dom element in order to facilitate in both environment (eg: Angular, React)
            let defaultToasterID = 'toast__wrap__el__react';
            let portalElement;
            const existingPortalElement = document.getElementById(defaultToasterID);
            if (existingPortalElement) {
                portalElement = existingPortalElement;
            }
            else {
                const customContainerForToast = document.createElement('div');
                customContainerForToast.id = defaultToasterID;
                customContainerForToast.className = 'Toaster';
                document.body.appendChild(customContainerForToast);
                portalElement = customContainerForToast;
            }
            return portalElement;
        };
        this.showToast = (options, setRetry) => {
            // Render toaster on UI
            ReactDOM.render(React.createElement(Toaster, { message: options.message, type: options.type, open: options.open, delay: options.delay, showCloseButton: options.showCloseButton, style: options.style, handleRetry: setRetry, handleClose: this.handleClose, isRetry: setRetry ? true : false, translateFn: options.translateFn }), this.getToasterContainer());
        };
    }
}
//# sourceMappingURL=toast.service.js.map